import { useSelector } from 'react-redux';
import { getCanAccessFeature } from '../../selectors/navigation';
import { getUserData } from '../../selectors/user';
import { SINGULAR_AI_FLAG, WATCHLIST_FEATURE } from '../constants';

const useMonitorAlertsEnabled = () => {
    const userData = useSelector(getUserData) || {};
    const canAccessWatchlist = useSelector(getCanAccessFeature(WATCHLIST_FEATURE));

    return (
        !!userData.email &&
        !userData.should_block_app &&
        (userData.feature_flags || []).includes(SINGULAR_AI_FLAG) &&
        canAccessWatchlist
    );
};

export default useMonitorAlertsEnabled;
